import $ from "jquery";

export const addToBookmarks = () => {
    $(document).on('click', '.bookmark', function () {
        const bookmark = $(this);
        const materialContentPartsWrapper = $(this).parents('.material-content__parts-wrapper');

        if (bookmark.data('url') === undefined) {
            return;
        }

        $.get(
            bookmark.data('url'),
            {data: materialContentPartsWrapper.data('id')},
            (response) => {
                if (response.error !== undefined) {
                    return;
                }

                bookmark.toggleClass('bookmark--active');
            }, 'json');
    });
};
